import { createContext, useState, useEffect } from "react";
import Swal from 'sweetalert2'
export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [itms, setItms] = useState({});



    const addToCart = (product) => {
        const existingProduct = cart.find((item) => item.id === product.id);
        if (existingProduct) {
            setCart(
                cart.map((item) =>
                    item.id === product.id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                )
            );
        } else {
            setCart([...cart, { ...product, quantity: 1 }]);
        }
        Swal.fire({
            icon: 'success',
            title: 'Product added to cart',
            showConfirmButton: false,
            timer: 1500
        })
    };

    const removeFromCart = (productId) => {
        Swal.fire({
            icon: 'question',
            title: 'Do You Want To remove this product from cart?',
            showConfirmButton: true,
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                setCart(cart.filter((item) => item.id !== productId));
            }
        })
    }

    const updateQuantity = (productId, quantity) => {

        if (quantity < 1) {
            removeFromCart(productId);
        } else {
            setCart(
                cart.map((item) =>
                    item.id === productId ? { ...item, quantity } : item
                )
            );
        }
    }
    const emptyCart = () => {
        setCart([]);
        localStorage.removeItem("cart");
    }

    useEffect(() => {
        const savedCart = localStorage.getItem("cart");
        if (savedCart) {
            setCart(JSON.parse(savedCart));
        }
    }, []);

    // Save cart to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart));
    }, [cart]);

    const totalMRP = cart.reduce((acc, item) => acc + item.product_mrp * item.quantity, 0);
    const totalDP = cart.reduce((acc, item) => acc + item.product_dp * item.quantity, 0);
    const totalBV = cart.reduce((acc, item) => acc + item.product_bv * item.quantity, 0);

    // Generate an array of productId and quantity for server
    const cartDetails = cart.map((item) => ({
        productId: item.id,
        quantity: item.quantity,
    }));

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, totalBV, totalDP, totalMRP, cartDetails, emptyCart }}>
            {children}
        </CartContext.Provider>
    );
};
